module.exports = __webpack_public_path__ + "res/img/icon-play.ea0b1522.png";